import { render, staticRenderFns } from "./read-more.vue?vue&type=template&id=a92f9fa0&scoped=true"
import script from "./read-more.vue?vue&type=script&lang=js"
export * from "./read-more.vue?vue&type=script&lang=js"
import style0 from "./read-more.vue?vue&type=style&index=0&id=a92f9fa0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@2.1.1_webpack@4.47.0__lodash@4.17.21_vu_3eef67c0e1ef2ea3d089dafcd6c47d43/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f9fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/phuongle/Documents/MAV/deploy 1001/1001-optical-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a92f9fa0')) {
      api.createRecord('a92f9fa0', component.options)
    } else {
      api.reload('a92f9fa0', component.options)
    }
    module.hot.accept("./read-more.vue?vue&type=template&id=a92f9fa0&scoped=true", function () {
      api.rerender('a92f9fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/read-more.vue"
export default component.exports